import React from "react";

import CircularProgress from "@mui/material/CircularProgress";
import ContainerForClinic from "./ContainerForClinic";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import {
  selectClinicList,
  selectLoading,
  selectSortConfig,
  selectClinicCurrentPage,
  selectClinicTotalPages,
} from "store/ClinicStore/selectors";
import {
  goToPageClinics,
  changeSortOfClinicList,
} from "store/ClinicStore/actions";
import { StatusENUM } from "../../../types/common";

const ClinicListContainer: React.FC<{
  disableClinic: (clinicId: string, status: StatusENUM) => void;
  editClinic: (clinicId: string) => void;
  addClinicAdmin: (clinicId: string) => void;
}> = ({ disableClinic, editClinic, addClinicAdmin }) => {
  const dispatch = useAppDispatch();
  const clinicList = useAppSelector(selectClinicList);
  const currentPage = useAppSelector(selectClinicCurrentPage);
  const totalPages = useAppSelector(selectClinicTotalPages);
  const sortConfig = useAppSelector(selectSortConfig);
  const isLoading = useAppSelector(selectLoading);

  const onClick = (sortBy: string) => {
    dispatch(changeSortOfClinicList(sortBy));
  };

  const onPageChange = React.useCallback(
    (_ev: React.ChangeEvent<unknown>, page: number) => {
      dispatch(goToPageClinics(page));
    },
    [dispatch]
  );

  return isLoading ? (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
        marginTop: "40px",
      }}
    >
      <CircularProgress color="inherit" size={50} />
    </div>
  ) : (
    <div className="mt-6 flex flex-col white-space-nowrap pb-16">
      <ContainerForClinic
        clinicList={clinicList}
        onClick={onClick}
        sortConfig={sortConfig}
        loading={isLoading}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={onPageChange}
        editClinic={editClinic}
        disableClinic={disableClinic}
        addClinicAdmin={addClinicAdmin}
      />
    </div>
  );
};

export default ClinicListContainer;
